<template>
    <base-form @submit="onSubmit">
        <vue-recaptcha
            ref="recaptcha"
            :sitekey="google_recaptcha_key"
            size="invisible"
            badge="bottomleft"
            @verify="onVerify"
            @expired="onExpired"
        />

        <slot />
    </base-form>
</template>

<script>
    import _ from 'lodash'
    import BaseForm from './base-form'
    import VueRecaptcha from 'vue-recaptcha'

    export default {
        props: {
            value: {
                validator: value => typeof value === 'string' || value === null,
                required: true
            }
        },
        components: {
            BaseForm,
            VueRecaptcha
        },
        data () {
            return {
                recaptcha: null
            }
        },
        computed: {
            google_recaptcha_key () {
                return _.preload('keys.google-recaptcha')
            }
        },
        watch: {
            recaptcha () {
                this.$emit('input', this.recaptcha)
            }
        },
        created () {
            this.$validator.$on('set', this.onExpired)
        },
        methods: {
            onSubmit () {
                this.recaptcha
                    ? this.emitSubmit()
                    : this.$refs.recaptcha.execute()
            },
            onVerify (recaptcha) {
                this.recaptcha = recaptcha

                this.emitSubmit()
            },
            emitSubmit () {
                this.$emit('submit')
            },
            onExpired () {
                this.recaptcha = null

                if (this.$refs.recaptcha) this.$refs.recaptcha.reset()
            }
        }

    }
</script>
